import { render, staticRenderFns } from "./SttrN_Details.vue?vue&type=template&id=0cc32126"
import script from "./SttrN_Details.vue?vue&type=script&lang=js"
export * from "./SttrN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports